import React, { useState, useMemo } from "react";
import { FaDownload, FaSearch } from "react-icons/fa";
import { getInitialDate, toISODateInput } from "../../../helper/formatDate";
import { Autocomplete, Button, FormInput, FormLabel } from "../../../components/ui";
import { useDebounce } from "../../../hooks/useDebounce";
import { useDoctorTreatmentAutocomplete } from "../../../hooks/doctor/useDoctorTreatmentAutocomplete";

import "./medicalTreatmentRecordHeader.css";

const MedicalTreatmentRecordHeader = ({
  formData,
  setFormData,
  onSearchMedicalRecordClicked,
  onDownloadMedicalRecordClicked,
}) => {
  const [selectedTreatmentSuggestion, setSelectedTreatmentSuggestion] = useState(null)
  const [shouldFetchSuggestion, setShouldFetchSuggestion] = useState(false)

  const debouncedMedicalTreatmentInput = useDebounce(formData.doctor_treatment.name.toLowerCase());
  const { data: medicalTreatmentList } = useDoctorTreatmentAutocomplete(
    debouncedMedicalTreatmentInput,
    shouldFetchSuggestion
  )

  const suggestionOptions = useMemo(() => {
    if (!formData.doctor_treatment.name) return []
    if (formData.doctor_treatment.name === selectedTreatmentSuggestion?.label) return []
    return medicalTreatmentList.map((item) => ({
      id: item.doctor_treatment_id,
      label: item.doctor_treatment_name,
    }))
  }, [formData.doctor_treatment, medicalTreatmentList, selectedTreatmentSuggestion])

  function handleChangeSuggestion(value) {
    setShouldFetchSuggestion(true)
    setSelectedTreatmentSuggestion(null)
    setFormData((prevState) => ({
      ...prevState,
      doctor_treatment: {
        id: '',
        name: value,
      },
    }))
  }

  function handleSelectSuggestion(suggestionData) {
    setShouldFetchSuggestion(false)
    setSelectedTreatmentSuggestion(suggestionData)
    setFormData((prevState) => ({
      ...prevState,
      doctor_treatment: {
        id: suggestionData.id,
        name: suggestionData.label,
      },
    }))
  }

  return (
    <div className="mb-3 py-2 flex justify-between items-end">
      <div className="flex items-end space-x-3">
        <div className="relative" style={{ width: '20rem' }}>
          <FormLabel htmlFor="medical-treatment-input">Tindakan Medis:</FormLabel>
          <FormInput
            id="medical-treatment-input"
            placeholder="Masukkan nama tindakan medis..."
            value={formData.doctor_treatment.name}
            onChange={(evt) => handleChangeSuggestion(evt.target.value)}
            style={{ marginBottom: 0 }}
            autoComplete="off"
          />
          <Autocomplete
            value={selectedTreatmentSuggestion}
            options={suggestionOptions}
            onChange={(value) => handleSelectSuggestion(value)}
          />
        </div>
        <div className="relative">
          <FormLabel htmlFor="start-date-input">Tanggal Mulai Periode:</FormLabel>
          <FormInput
            id="start-date-input"
            type="date"
            value={formData.start_date}
            max={toISODateInput(getInitialDate('daily'))}
            onChange={(evt) => {
              setFormData((prevState) => ({
                ...prevState,
                start_date: evt.target.value
              }))
            }}
          />
        </div>
        <div className="relative">
          <FormLabel htmlFor="end-date-input">Tanggal Akhir Periode:</FormLabel>
          <FormInput
            id="end-date-input"
            type="date"
            value={formData.end_date}
            max={toISODateInput(getInitialDate('daily'))}
            onChange={(evt) => {
              setFormData((prevState) => ({
                ...prevState,
                end_date: evt.target.value
              }))
            }}
          />
        </div>
        <Button
          variant="primary"
          onClick={() => {
            setShouldFetchSuggestion(false)
            onSearchMedicalRecordClicked()
          }}
        >
          <FaSearch className="mr-2" /> Cari
        </Button>
      </div>
      <div className="ml-auto flex items-center space-x-3">
        <Button
          variant="success"
          onClick={() => onDownloadMedicalRecordClicked()}
        >
          <FaDownload className="mr-2" /> Download Excel
        </Button>
      </div>
    </div>
  );
};

export default MedicalTreatmentRecordHeader;
